const React = require('react');
const { PureComponent } = require('react');
require('./industries.css');

const Industry = (props) => {
    let className = 'industry';
    if (props.isSelected) {
        className += ' selected';
    }
    const title = `Select '${  props.name  }' industry`
    return (
        <button
            type="button"
            title={title}
            onClick={() => { props.onSelect(props.name); } }
            className={className}>
                {props.name}
        </button>
    );
};

class Industries extends PureComponent {

    render() {
        return (
            <div className="industries-container">
                <div className="help-text">Choose an industry to get started</div>
                <div className="industries">
                    {this.props.jsonConfig.industries.map((industry) => (
                        <Industry
                            key={industry}
                            name={industry}
                            onSelect={this.props.selectIndustry}
                            isSelected={this.props.selectedIndustry === industry}
                        />
                    ))}
                </div>
            </div>
        );
    }
}

module.exports = Industries;



// WEBPACK FOOTER //
// ./src/components/Industries/industries.js